import posthog from 'posthog-js'
import { version as appVersion } from '../../package.json'

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST as string | undefined

export const isPostHogEnabled = Boolean(POSTHOG_KEY)

if (isPostHogEnabled) {
  posthog.init(POSTHOG_KEY!, {
    api_host: POSTHOG_HOST ?? 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_exceptions: true,
  })

  posthog.register({
    app_name: 'rsp-backoffice',
    app_version: appVersion,
  })
}

export { posthog }
